/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

//////////////////////////////////////////////////////////////////////////
// Function for cart drawer expansion
//////////////////////////////////////////////////////////////////////////

let giftCheck = getCookie("free_gift");
let freeLocked = document.getElementById("drawer-free-item-locked");
let freeUnlocked = document.getElementById("drawer-free-item-unlocked");

function expand(e){
  let popularProducts = document.getElementById('popular-products');
  let expander = document.getElementById('popular-products-expand');


  if (e.target == expander || e.target.tagName == 'H5') {
    popularProducts.classList.toggle("is-active");
  }

}

//////////////////////////////////////////////////////////////////////////
// Add to Cart button for Cart Drawer Upsell
//////////////////////////////////////////////////////////////////////////

function addToCart(id){
  $.ajax({
    url: '/cart/add.js',
    type: 'post',
    dataType: 'json',
    contentType: 'application/json',
    success: function () {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

      let count = document.querySelectorAll('.cart-count')[0];
      current_count = parseInt(count.innerHTML, 10);
      current_count += 1;
      count.innerHTML = current_count;
    },
    data: JSON.stringify({quantity: 1, id: id})
  });

};

//////////////////////////////////////////////////////////////////////////
// Mobile popular product slider
//////////////////////////////////////////////////////////////////////////

let slidePosition = 0;
const slides = document.getElementsByClassName('slide');
const totalSlides = slides.length;

function updateSlidePosition() {
  for (let slide of slides) {
    slide.classList.remove('slide-active');
//     slide.classList.add('slide-hidden');
  }

  slides[slidePosition].classList.add('slide-active');
}

function moveToNextSlide() {
  if (slidePosition === totalSlides - 1) {
    slidePosition = 0;
  } else {
    slidePosition++;
  }

  updateSlidePosition();
}

function moveToPrevSlide() {
  if (slidePosition === 0) {
    slidePosition = totalSlides - 1;
  } else {
    slidePosition--;
  }

  updateSlidePosition();
}


//////////////////////////////////////////////////////////////////////////
// Refresh Cart Helper
//////////////////////////////////////////////////////////////////////////

function addProduct(){
  console.log("product added called");
  document.dispatchEvent(new CustomEvent('product:added', { bubbles: true }));
}

function refreshCart(){
  document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); 
}

if (window.location.pathname != "/cart") {
    const cartDrawer = document.getElementById("sidebar-cart");
    cartDrawer.addEventListener("transitionstart", () => {
    refreshCart();    
  });
}


//////////////////////////////////////////////////////////////////////////
// Remove from cart page
//////////////////////////////////////////////////////////////////////////

async function removeFromCart(idx, isFreeGift) {
// 	if (isFreeGift) {
// 		setCookie("free_gift", "declined");
// 	}


	let res = await fetch("/cart/change.js", {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({line: idx, quantity: 0})
	})
    
    document.dispatchEvent(new CustomEvent('gift:eval', { bubbles: true }));
    
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
}
